<app-progress #progress (stateChange)="onStateChange($event)" [stepsLabels]="stepsLabels">
  <app-progress-step *ngIf="isStandard">
    <app-upload-media
      [multiple]="false"
      [isCustomUrl]="true"
      [onlyCustomURL]="false"
      [customURL]="uploadGroup.controls['imageUrl'].value"
      (imagesUrlChanged)="imageChanged($event)"
      [mediaRequirements]="photoRequirements"
      [mediaTitle]="photoRequirementsTitle"
    ></app-upload-media>
  </app-progress-step>
  <app-progress-step [formGroup]="covid19UpdateForm">
    <app-post-info
      *ngIf="activeIndex === 1"
      [postInfoGroup]="postDetailsGroup"
      [type]="isStandard ? 'update' : 'covid19'"
    ></app-post-info>
  </app-progress-step>
  <app-progress-step>
    <app-abp-date-locations-form
      [displayScheduleLaterSwitch]="true"
      [scheduleGroup]="scheduleGroup"
      [rows]="2"
      [width]="'87vw'"
    ></app-abp-date-locations-form>
  </app-progress-step>
  <app-progress-step>
    <app-submit *ngIf="activeIndex === 3" [form]="covid19UpdateForm" [preSelectedLocs]="preSelectedLocation.length"></app-submit>
  </app-progress-step>
</app-progress>

<div class="bottom-buttons">
  <button *ngIf="activeIndex === 0" pButton label="CANCEL" class="p-button-outlined" (click)="closeDialog()"></button>
  <button *ngIf="activeIndex > 0" pButton label="BACK" class="p-button-outlined" progressStepPrev></button>
  <button
    pButton
    label="SAVE AND NEXT"
    class="p-button-primary"
    [disabled]="!covid19UpdateForm.controls[formGroupName].valid || checkAddButtonStatus || checkDateAndLocStatus"
    (click)="goNext(progress)"
  ></button>
  <button pButton *ngIf="activeIndex === 0" (click)="goNext(progress)" label="SKIP"></button>
</div>
